<template>
<div class="pagination">
    <el-pagination
        background
        layout="prev, pager, next"
        :total="pageData.total"
        :page-size="pageData.pageSize"
        :current="pageData.current"
        @current-change="changePage"
    >
    </el-pagination>
</div>
</template>
<script>
export default {
    name: "pagination",
    props: {
        pageData: {
            type: Object,
            // 对象或数组默认值必须从一个工厂函数获取
            default: function () {
                return {
                    total: 1,//总条数
                    pageSize: 10,//每页多少条
                    current:1,//当前页
                    totalPage:1,//总页数数
                }
            }
        }
    },
    components: {

    },
    data() {
        return {

        }
    },
    created() {
    },
    methods: {
        changePage(value) {
            this.$emit('changePage',value)
        }
    }
}
</script>

<style lang="less">
.pagination {
    overflow: hidden;
    padding-top: 23px;
    padding-bottom: 23px;
    .el-pagination {
        float: right;
    }
}
</style>